/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PlatformTaskResponse {
    getFixupPrototypeFunction() { return PlatformTaskResponse.fixupPrototype; }

    static newInstance(model: Partial<PlatformTaskResponse>): PlatformTaskResponse {
        let obj = Object.assign(new PlatformTaskResponse(), model);
        PlatformTaskResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PlatformTaskResponse>): PlatformTaskResponse {
        if (!model) return null;
        return PlatformTaskResponse.newInstance(<PlatformTaskResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PlatformTaskResponse) {
        if (!obj) return;

        models.PlatformTaskResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PlatformTaskResponse): boolean {
        Object.setPrototypeOf(obj, PlatformTaskResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.assigned_tasks) {
            for (let val of this.assigned_tasks) {
                models.PlatformAssignedTasks.fixupPrototype(val);
            }
        }
    }

    /**
     * Service Account ID
     */
    service_account_id: string;

    /**
     * Assigned tasks
     */
    assigned_tasks: Array<models.PlatformAssignedTasks>;

}
